import { useState, useEffect } from 'react';

interface ViewportHeight {
  height: number;
  availableHeight: number; // Height minus header/navbar
}

export const useViewportHeight = (): ViewportHeight => {
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    const updateHeight = () => {
      // Get full viewport height
      const viewportHeight = window.innerHeight;
      setHeight(viewportHeight);
    };

    // Set initial height
    updateHeight();

    // Add event listener for resize
    window.addEventListener('resize', updateHeight);

    // Cleanup
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  // Calculate available height (subtract estimated header/sidebar height)
  const headerHeight = 120; // Approximate header + navigation height
  const availableHeight = Math.max(height - headerHeight, 400); // Min 400px

  return {
    height,
    availableHeight,
  };
};